import { css } from 'styled-components';

export const gradientPillCss = css`
  position: relative;
  min-height: 44px;
  padding: 12px 16px;
  border-radius: 999px;
  background: linear-gradient(90deg, #8debff 0%, #f8c9a5 100%);
  color: #111827;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.3px;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.18),
    0 8px 24px rgba(141, 235, 255, 0.25);
  cursor: pointer;
  transition: transform 0.06s ease, box-shadow 0.15s ease, filter 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    inset: 1px;
    border-radius: 999px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0) 60%);
    pointer-events: none;
  }

  &:hover {
    box-shadow:
      0 3px 10px rgba(0, 0, 0, 0.22),
      0 10px 32px rgba(141, 235, 255, 0.3);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow:
      0 2px 6px rgba(0, 0, 0, 0.22),
      0 6px 20px rgba(141, 235, 255, 0.25);
  }

  &:focus-visible {
    outline: 2px solid #8ab4f8;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
    filter: saturate(0.6);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
